import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, Grid } from '@tempmee/react';
import Styles from './FiltersCard.module.scss';

/**
 * The Figma frame is five equal columns with 8px gutters, min ~220px each.
 * `auto-fill` rather than a fixed five keeps the card usable inside the shell's
 * content column — columns drop out as the pane narrows instead of the fields
 * squeezing to slivers. `Grid` takes a template string for exactly this.
 *
 * `min-h-0` overrides Card's own `min-h-20`: an 80px floor leaves a single row
 * of fields (72px with the padding) sitting above 8px of dead space that reads
 * as lopsided bottom padding. The card should be exactly its fields plus p-4.
 */
export const FiltersCard = ({ children }) => (
  <Card className="min-h-0 rounded-lg p-4">
    <Grid columns="repeat(auto-fill, minmax(220px, 1fr))" gap={2}>
      {children}
    </Grid>
  </Card>
);

/**
 * A child that spans the whole grid row — for content that isn't a field, like
 * a date-range readout or an expandable picker. `grid-column: 1 / -1` has no
 * design-system prop, hence the module class.
 */
const FullRow = ({ children }) => <Box className={Styles.fullRow}>{children}</Box>;

FullRow.propTypes = { children: PropTypes.node };
FullRow.defaultProps = { children: null };

FiltersCard.FullRow = FullRow;

FiltersCard.propTypes = {
  /** Filter fields — text inputs, selects — placed onto the grid in order. */
  children: PropTypes.node,
};

FiltersCard.defaultProps = { children: null };

export default FiltersCard;
